import { css } from 'styled-components';
import { rem, media } from '../../../helpers/mixins';
import arrowDown from '../../../assets/images/icons/arrowDown.svg';
import arrowDownBlack from '../../../assets/images/icons/arrowDownBlack.svg';
import { WHITE, GRAY_TEXT, LABEL_COLOR } from '../../../constants/colors';

export default {
  wrapper: ({ hasBlackTheme, isSorting }) => css`
    display: flex;
    flex-direction: column;

    ${media.sm && css`
      // margin-top: ${hasBlackTheme || isSorting ? 0 : 12}px;
    `}

    ${hasBlackTheme && css`
      margin-bottom: 24px;
    `}

    ${isSorting && css`
      margin: 0;
      padding: 0;
    `}
  `,
  selectWrapper: css`
    position: relative;
    width: 100%;
    display: grid;
    grid-template-columns: 150px 70px 150px;
    grid-template-rows: 60px 60px 60px;
    padding: 10px;
    row-gap: 10px;

    ${media.sm`
      display: flex;
    `}
  `,

  selectWrapperTitle: css`
  position: relative;
  display: flex;
  width: auto;
  justify-content: center;
  text-align: center;
  margin: auto;
  padding-left: 25px;
    ${media.sm`
      margin: initial;
      padding-left: 0px;
      -webkit-justify-content: flex-start;
    `}
`,
  select: ({ hasBlackTheme, value, isSorting }) => css`
    position: relative;
    color: ${hasBlackTheme || isSorting ? LABEL_COLOR : WHITE};
    width: 100%;
    font-size: ${isSorting ? rem('12px') : rem('16px')};
    border: none;
    box-shadow: none;
    border-radius: 0;
    background-color: transparent;
    background-image: none;
    appearance: none;
    outline: none;
    border-bottom: ${isSorting ? 'none' : `1px solid ${hasBlackTheme ? '#ccc' : GRAY_TEXT}`};

    &:focus {
      border-bottom: ${isSorting ? 'none' : `1px solid ${hasBlackTheme ? LABEL_COLOR : WHITE}`};
    }

    ${value === '' && hasBlackTheme && css`
      color: #757575;
    `}

    ${isSorting && css`
      border: none;
    `}

    option {
      color: black;
      font-size: ${rem('16px')};
    }
  `,

  selectArrow: ({ hasBlackTheme, isSorting }) => css`
    position: absolute;
    bottom: ${isSorting ? 6 : 8}px;
    right: ${isSorting ? 12 : 8}px;
    width: 10px;
    height: 6px;
    background-image: url(${hasBlackTheme || isSorting ? arrowDownBlack : arrowDown});
    background-repeat: no-repeat;
    pointer-events: none;
  `,
  name: ({ color }) => css`
    font-size: ${rem('100px')};
    margin-top: 4px;
  `,

  title: ({color, visibility}) => css`
  color: ${color || GRAY_TEXT};
  font-size: 10px;
  margin-top: 4px;
  margin-inline:3px; 

    ${media.sm`
      font-size: ${rem('16px')};
      margin-inline: 4%;
      visibility:${visibility}
    `}
  `,

  inputRounder: ({ type, width,  padding, hasBlackTheme, value, isSorting, textColor }) => css`
    border-radius: 10px;
    border-radius: 10px;
    border: 1px solid ${GRAY_TEXT};
    font-weight: 900;
    color: #292033;
    padding-inline: 15px 0px;
    width: ${ width || "auto" };
    margin-left ${padding || 0};
    border: ${isSorting ? 'none' : `1px solid ${hasBlackTheme ? '#ccc' : GRAY_TEXT}`};

    &:focus {
      border: ${isSorting ? 'none' : `1px solid ${hasBlackTheme ? LABEL_COLOR : WHITE}`};
    }

    ${value === '' && hasBlackTheme && css`
      color: #757575;
    `}

    ${isSorting && css`
      border: none;
    `}

    ${type === 'date' && !textColor && css`
      &::-webkit-calendar-picker-indicator {
        filter: invert(1);
      }
    `}
    option {
      color: black;
      font-size: ${rem('16px')};
    }
    ${media.md`
      width:500px
    `}
  `,

  labelInput: ({color}) => css`
    color: ${color || GRAY_TEXT};
    font-size: ${rem('13px')};
    margin-top: 4px;
    padding-left: 13px;
  `,

  inputsWrapper:({margin, marginRight}) => css` 
    display: grid;
    padding: 2px;
    margin-top: 10px;
    // margin-inline:${margin || "auto"};
    // margin-right:${marginRight || "auto"};

    ${media.sm`
      margin-inline:1%;
    `}
  `,


  pinkButton:({}) => css` 
    background-color: #EF60A3;
    width: 100px;
    border-radius: 10px;
    color:white;
    height: 32px;
    text-align: center;
 
  `,
};


